
class Raf
{
    constructor()
    {
        this._onRafCb = []
        this.time = Date.now()
        this.dt = 1000 / 60

        this._raf = requestAnimationFrame(this._update.bind(this))
    }

    dispose()
    {
        cancelAnimationFrame(this._raf)
    }

    _update()
    {
        const time = Date.now()
        const dt = time - this.time

        this.dt = dt
        this.time = time

        for (const cb of this._onRafCb)
        {
            cb(dt, time)
        }

        this._raf = requestAnimationFrame(this._update.bind(this))
    }


    //  ---------
    //  LISTENERS
    //  ---------

    /**
     * Add a listener called at every frame.
     *
     * @param {Function} callback   Called if new frame with the delta time in
     *                              milliseconds and the time in milliseconds
     * @returns {Boolean} Success
     */
    addOnFrame(callback)
    {
        this.removeOnFrame(callback)
        this._onRafCb.push(callback)

        return true
    }

    /**
     * Remove the listener.
     *
     * @param {Function} callback   Same function precedently added
     * @returns {Boolean} Success
     */
    removeOnFrame(callback)
    {
        const i = this._onRafCb.indexOf(callback)
        if (i > -1)
        {
            this._onRafCb.splice(i, 1)
            return true
        }

        return false
    }
}

export default Raf



// WEBPACK FOOTER //
// ./src/scripts/mixins/core-raf/Raf.js